import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error" }

import { ref, reactive, computed, onMounted } from "vue";
import { useStore } from "vuex";
import type { FieldSchema } from "@/models/form";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import NextButton from "@/components/shared/NextButton.vue";
import { $api } from "@/services/api";
import useValidation from "@/use/validation";
import type { ConsentForm } from "@/models/consents";

interface Props {
  applicant: Applicant;
  stip: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RefiUnderpaymentConsent',
  props: {
    applicant: {},
    stip: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const { validate } = useValidation();

const store = useStore();

const props = __props;

const emit = __emit;

let consents = ref({} as any);

const error = ref<boolean>(false);
const submittingData = ref<boolean>(false);
const refiUnderpaymentConsent = ref<boolean | undefined>(undefined);
const refiUnderpaymentConsentTypeId = computed<number>(
  () =>
    store.state.lookupsModule?.consentTypes?.find(
      (ct: any) => ct.name?.trim()?.toLowerCase() === "RefiUnderpayment".toLowerCase(),
    )?.id,
);
const schema = reactive<FieldSchema>({
  type: "checkbox",
  hideLabel: true,
  label: "I agree",
  errorMessage: "You must agree to submit",
  required: true,
} as FieldSchema);

function getConsent(consents: ConsentForm[], consentTypeId: number) {
  return (consents || [])?.find((q: ConsentForm) => q.consentTypeId === consentTypeId);
}
async function getConsents() {
  await store.dispatch("lookupsModule/getConsentTypes");
  const questions = await $api.consents.getAllConsents(props?.applicant?.id);
  if (questions.length > 0) {
    const refiUnderpaymentConsent = getConsent(questions, refiUnderpaymentConsentTypeId.value);

    consents.value.refiUnderpaymentConsentId = refiUnderpaymentConsentTypeId.value;
    consents.value.refiUnderpaymentConsent = refiUnderpaymentConsent?.consentGiven;
  }
}
async function saveRefiUnderpaymentConsent() {
  error.value = false;
  validate(schema, refiUnderpaymentConsent.value);

  if (schema.valid) {
    submittingData.value = true;

    const updateConsentStipulationRequest = {
      applicationId: store?.state?.appData?.application?.id || 0,
      applicantId: props?.applicant?.id || 0,
      stipulationId: props?.stip?.id,
      consentGiven: refiUnderpaymentConsent.value,
      updatedByUserId: props?.applicant?.userId,
    };

    const updateConsentStipulationResponse = await $api.applicant.updateApplicantConsentStipulation(
      updateConsentStipulationRequest,
    );

    if (
      updateConsentStipulationResponse?.stipulationId &&
      updateConsentStipulationResponse?.stipulationId > 0
    ) {
      let updatedStip = props.stip;
      updatedStip.stipulationStatusId = updateConsentStipulationResponse.stipulationStatusId;
      updatedStip.stipulationStatusName = updateConsentStipulationResponse.stipulationStatusName;
      emit("success", updatedStip);
      submittingData.value = false;
    } else {
      error.value = true;
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}

onMounted(() => {
  getConsents();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseFormField, {
      modelValue: refiUnderpaymentConsent.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refiUnderpaymentConsent).value = $event)),
      schema: schema,
      disabled: submittingData.value
    }, null, 8, ["modelValue", "schema", "disabled"]),
    _createVNode(NextButton, {
      text: "Submit",
      onClick: saveRefiUnderpaymentConsent,
      disabled: submittingData.value,
      loading: submittingData.value
    }, null, 8, ["disabled", "loading"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("p", null, " An error occurred while processing your acknowledgement. Please try again later. If the issue persists, please contact our support team. ", -1)
    ]))], 512), [
      [_vShow, error.value]
    ])
  ], 64))
}
}

})